var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wallet"}},[_c('img',{staticStyle:{"width":"90%","margin":"15px 0px"},attrs:{"src":require("../../assets/E-wallet.png")}}),_vm._v(" "),_c('h4',[_vm._v("Pay9-wallet OR "),_c('br'),_vm._v("Prompt Pay")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8ed219e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/TypeWallet.vue
// module id = 237
// module chunks = 1